// TODO: Please remove this file after the release of the new video page.
import { BaseVideoClickTracker } from '@/analytics/base_video_click_tracker';

export class TrackVideoClick extends BaseVideoClickTracker {
    getVideoItems() {
        this.videoItems = Array.from(this.$refs['related-videos'].querySelectorAll('.video-item'));
    }
}
